import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { AssetService } from '../../../services/asset.service';
import { Asset } from '../../../models/asset.model';
import { SystemService } from '../../../services/system.service';
import { Storage } from "@ionic/storage";
import { Platform, LoadingController, Loading, Spinner, ModalController, ViewController, AlertController } from 'ionic-angular';
import { Console } from '@angular/core/src/console';
import { ProjectService } from '../../../services/project.service';
import { PhysicalReading } from '../../../models/physical-reading';
import { DatabaseConfiguration } from '../../../database/database.configuration';
import { SQLite, SQLiteObject } from '@ionic-native/sqlite';
import { ManualPointService } from '../../../services/manual-point.service';
import { ManualPoint } from '../../../models/manual-point';
import { Report, LogReport } from '../../../models/report.model';
import { MobileDataService } from '../../../services/mobile-data.service';
import { Constants } from '../../../commons/constants';
import { saveAs } from 'file-saver';
import { CommentsDetailsComponent } from '../comments-details/comments-details.component';
import { EmailDetailsComponent } from '../email-details/email-details.component';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'physical-readings',
    templateUrl: 'physical-readings.html',
    providers: [TranslateService]
})
export class PhysicalReadingsComponent {
    public access_token: string;
    public manualPoints: ManualPoint[] = [];
    public showModal: boolean;
    public fromReadings: boolean = false;
    public flag: boolean = false;
    public showReportList: boolean = true;
    public uploaded: boolean = false;
    public readingsList: PhysicalReading[] = [];
    public fetchDataSpinner: Loading;
    public newPoint: any;
    public db: SQLiteObject;
    public logData: any[] = [];
    public asset: Asset;
    public check: boolean = false;
    public checkData:boolean=false;
    public currentReading: any = {};
    public currentIndex: number;
    public pdfPath: string;
    public lan:string;
    public isSend: boolean = false;
    public commnetModal: boolean = false;
    public point: PhysicalReading = {
        'id': null,
        'assetId': null,
        'assetName': null,
        'projectName': null,
        'points': []
    };
    public pdfData: any[] = [];
    public pdfUrl:string;
    public reportFileName:string;
    public htmlElementSelector:string;
    // @Output() downloadPdfEvent = new EventEmitter();
   // @Output() emailPdfEvent = new EventEmitter();
    @Output() removePdfComponent = new EventEmitter();
   // @Input() saveOrEmail: string;
   // @Output() showEmailModal = new EventEmitter();
    // @Input() saveOrEmail: string;


    constructor(
        private assetService: AssetService,
        private systemService: SystemService,
        private platform: Platform,
        private storage: Storage,
        private projectService: ProjectService,
        private loadingCtrl: LoadingController,
        private dbConfings: DatabaseConfiguration,
        private manualPointService: ManualPointService,
        private mobileDataService: MobileDataService,
        private constants: Constants,
        private viewCtrl: ViewController,
        private modalCtrl: ModalController,
        private alertCtrl: AlertController,
        public translate: TranslateService
    ) {
        this.showModal = this.systemService.get();
        this.newPoint = JSON.stringify(this.point);
    }

    ngOnInit() {
        //this.iniatePDFOperation(this.saveOrEmail);
        this.lan =sessionStorage.getItem("lang")
       // this.lan="cn";
        if (this.platform.is("mobileweb") || this.platform.is("core")) {
            this.access_token = sessionStorage.getItem('access_token');
            this.asset = this.assetService.get();
            this.fetchDataSpinner = this.loadingCtrl.create({
                content: this.translate.instant('Fetchingdata'),
                spinner: 'bubbles'
            });
            this.fetchDataSpinner.present();
            this.manualPointService.getLogReports(this.access_token, this.asset.id)
                .subscribe(reports => {
                    this.fetchDataSpinner.dismiss();
                    if (reports && reports.length > 0) {
                        this.readingsList = reports;
                    }
                    else {
                        this.flag = true;
                    }
                }, (error) => {
                    this.fetchDataSpinner.dismiss();
                })
        }
        else {
            this.storage.get('access_token').then((token) => {
                this.access_token = token;
            });
            let projectId = this.projectService.project.id;
            let promise = this.dbConfings.initializeDB();
            promise.then((db: SQLiteObject) => {
                this.db = db;
                //this.dropDB();
                this.db.executeSql('CREATE TABLE IF NOT EXISTS physical_readings (id INTEGER PRIMARY KEY AUTOINCREMENT, project_id TEXT, readings TEXT)', [])
                    .then(() => {

                        this.db.executeSql('select * from physical_readings where project_id=?', [projectId])
                            .then((data) => {
                                this.selectReadings(data);
                            })
                            .catch((error) => console.log("There was some error in fetching the Physical Readings table"));
                    })
                    .catch((error) => console.log("There was some error in creating the Physical Readings table"));
            });

        }
    }

    /* ------- Not Needed For Now -------- */

    dropDB() {
        this.db.executeSql('DROP TABLE physical_readings', [])
            .then((data) => console.log('Table dropped'))
            .catch((error) => console.log('Error while dropping table'))
    }

    insertIntoDB(value) {
        this.db.executeSql('INSERT INTO physical_readings (project_id, readings) VALUES (?,?)', [this.projectService.project.id, value])
            .then((data) => {
                console.log("Data inserted succesfully");
            })
            .catch((error) => console.log("There was some error in inserting values into Physical Readings table"));
    }

    deleteDB(row_id) {
        this.db.executeSql('DELETE FROM physical_readings WHERE id=?', [row_id])
            .then((data) => console.log('Row Deleted'))
            .catch((error) => console.log(JSON.parse(error)));
    }

    updateDB(value, row_id) {
        this.db.executeSql('UPDATE physical_readings SET readings=? WHERE id=? AND project_id=?', [value, row_id, this.projectService.project.id])
            .then((data) => {
                console.log('Updated');
            })
            .catch((error) => console.log(JSON.stringify(error)));
    }

    selectReadings(data: any) {
        if (data.rows && data.rows.length > 0) {
            for (let i = 0; i <= data.rows.length; i++) {
                let obj = JSON.parse(data.rows.item(i).readings);
                obj.id = data.rows.item(i).id;
                this.readingsList.push(obj);
            }
        }
    }

    /* --------- Starts From Here ----------- */

    showAssets() {
        this.showModal = !this.showModal;
        this.systemService.set(this.showModal);
    }

    changeSystem(asset) {
        this.assetService.set(asset);
        this.systemService.set(false);
        this.getManualPoints(this.access_token, this.assetService.asset.id);
        //this.mapManualPoints();
    }

    saveReport() {
        this.fetchDataSpinner = this.loadingCtrl.create({
            content: this.translate.instant('SavingData'),
            spinner: 'bubbles'
        });
        this.fetchDataSpinner.present();
        if (this.platform.is("mobileweb") || this.platform.is("core")) {
            //If part is for the new report being saved and else if for the existing report being saved
            if (!this.fromReadings) {
                this.point.id = this.constants.GUID_GENERATOR();
                this.point.assetId = this.assetService.asset.id;
                this.point.assetName = this.assetService.asset.name;
                this.point.projectName = this.projectService.project.name;
                let timestamp =Math.floor(Date.now()).toString();
                this.point.points.forEach((el) => {
                    el.timestamp = timestamp;
                });
                let body = {
                    "assetId": this.asset.id,
                    "reportData": JSON.stringify(this.point),
                    "flag": false,
                    "randomnumber": 0,
                    "projectname": this.projectService.project.name
                }
                for (var i = 0; i < JSON.parse(body.reportData).points.length; i++) {
                    if (JSON.parse(body.reportData).points[i].value) {
                        this.checkData = true;
                    }
                }
                if (this.checkData) {
                    this.manualPointService.saveLogReportsToDB(this.access_token, body).subscribe(success => {
                        this.fromReadings = false;
                        this.showReportList = true;
                        this.flag = false;
                        this.manualPointService.getLogReports(this.access_token, this.asset.id)
                            .subscribe(reports => {
                                this.fetchDataSpinner.dismiss();
                                if (reports && reports.length > 0) {
                                    this.readingsList = reports;
                                }
                                else {
                                    this.flag = true;
                                }
                            }, (error) => {
                                this.fetchDataSpinner.dismiss();
                            })
                    }, (error) => {
                        this.fetchDataSpinner.dismiss();
                    })
                }
                else {
                    this.fetchDataSpinner.dismiss();
                    let alert = this.alertCtrl.create({
                        subTitle: this.translate.instant('Pleaseenteravalue'),
                        buttons: [this.translate.instant('OK')]
                    });
                    alert.present();
                }
            }
            else {
                let body = {
                    "assetId": this.asset.id,
                    "reportData": JSON.stringify(this.point),
                    "flag": false,
                    "randomnumber": this.currentReading.RandomNumber,
                    "projectname": this.projectService.project.name
                }
                this.manualPointService.saveLogReportsToDB(this.access_token, body).subscribe(success => {
                    this.fetchDataSpinner.dismiss();
                    this.currentReading['ReportData'] = JSON.stringify(this.point);
                    this.fromReadings = false;
                    this.showReportList = true;
                    this.flag = false;
                }, (error) => {
                    this.fetchDataSpinner.dismiss();
                })
            }
        }
    }

    valueUpdated(point) {
        let index;
        index = this.point.points.indexOf(point);
        this.point.points[index].timestamp = Math.floor(Date.now()).toString();
    }

    mapManualPoints() {
        this.manualPoints[0].data.map((el, index) => {
            this.point.points.push({
                'pointId': el.PointId,
                'pointName': el.description,
                'unitName': el.fromunit,
                'value': '',
                'timestamp': ''
            });
        });
    }

    addReport() {
        this.getManualPoints(this.access_token, this.assetService.asset.id);
        this.fromReadings = false;
        this.showReportList = false;
        this.flag = false;
    }

    showReadings(reading, index) {
        this.currentReading = reading;
        this.currentIndex = index;
        this.fromReadings = true;
        this.point = JSON.parse(reading.ReportData);
        this.showReportList = false;
    }

    back() {
        this.fetchDataSpinner = this.loadingCtrl.create({
            content: this.translate.instant('Fetchingdata'),
            spinner: 'bubbles'
        });
        this.fetchDataSpinner.present();
        this.fromReadings = false;
        this.point = JSON.parse(this.newPoint);
        this.showReportList = true;
        if (this.uploaded) {
            this.flag = false;
        }
        this.uploaded = false;
        this.manualPointService.getLogReports(this.access_token, this.asset.id)
        .subscribe(reports => {
            this.fetchDataSpinner.dismiss();
            if (reports && reports.length > 0) {
                this.readingsList = reports;
            }
            else {
                this.flag = true;
            }
        }, (error) => {
            this.fetchDataSpinner.dismiss();
        })
    }

    uploadData() {
        // this.removePdfComponent.emit();
        //debugger;
        // this.commnetModal=true;
        // let modal = this.modalCtrl.create(CommentsDetailsComponent, {
        //     // pdfData: base64
        //    })
        //    modal.present();
        // this.isSend=true;
        let alert = this.alertCtrl.create({
            title: this.translate.instant('Comments'),
            inputs: [
                {
                    type: 'textarea',
                    name: 'comments',
                    placeholder: this.translate.instant('Comments')
                },
            ],
            buttons: [
                {
                    text: this.translate.instant('ok'),
                    handler: data => {
                        this.upload(data["Comments"]);
                    }
                },
                {
                    text: this.translate.instant('Cancel'),
                    role: 'cancel',
                    handler: data => {
                    }
                }

            ],
            cssClass: 'alertCustomCss'
        });
        alert.present();



    }

    // iniatePDFOperation(type) {

    //     debugger;
    //             this.removePdfComponent.emit(false);
    //         }

    upload(data) {
        let self = this;
        let logReport: any = {
            'assetId': '',
            'assetName': '',
            'projectName': '',
            'comment': '',
            'report': [],
            'lang':'',
            'language':''
        };
        logReport.assetId = this.assetService.asset.id;
        logReport.assetName = this.assetService.asset.name;
        logReport.projectName = this.projectService.project.name;
        logReport.comment = data;
        logReport.lang = this.lan;
        logReport.language = this.lan;
        logReport.report = this.point.points.map((el) => {
            return {
                pointId: el.pointId,
                value: el.value,
                timestamp: self.formatDate()
            }
        });

        for (var i = 0; i < logReport.report.length; i++) {
            if (logReport.report[i].value) {
                this.check = true;
            }
        }
        if (this.check) {
            this.fetchDataSpinner = this.loadingCtrl.create({
                content: this.translate.instant('SavingData'),
                spinner: 'bubbles'
            });
            this.fetchDataSpinner.present();
            let body = {
                "assetId": this.asset.id,
                "reportData": JSON.stringify(this.point),
                "flag": true,
                "randomnumber": this.currentReading['RandomNumber'] || 0,
                "projectname": this.projectService.project.name
            }
            this.manualPointService.saveLogReportsToDB(this.access_token, body).subscribe(success => {
                this.manualPointService.postManualPoints(this.access_token, logReport)
                    .subscribe((data) => {
                        this.fromReadings = false;
                        this.showReportList = true;
                        this.flag = true;
                        this.uploaded = true;
                        //this.getMobileData(logReport.assetId);
                        this.getMobileDataLogReport(logReport);
                        if (this.platform.is("mobileweb") || this.platform.is("core")) {
                            if (this.currentReading['RandomNumber']) {
                                this.readingsList.splice(this.currentIndex, 1);
                            }
                            let value = JSON.stringify(this.readingsList);
                            sessionStorage.setItem(this.projectService.project.id, value);
                        } else {
                            this.deleteDB(this.point.id);
                            this.readingsList.splice(this.readingsList.indexOf(this.point), 1);
                        }

                    }, (error) => this.fetchDataSpinner.dismiss());
            }, (error) => this.fetchDataSpinner.dismiss());
        }
        else {
            // this.presentToast();
            this.fetchDataSpinner.dismiss();
            let alert = this.alertCtrl.create({
                subTitle: this.translate.instant('Pleaseenteravalue'),
                buttons: [this.translate.instant('OK')]
            });
            alert.present();
        }
    }

    getMobileDataLogReport(body) {
        this.mobileDataService.getMobileDataLogReport(this.access_token, body)
            .subscribe((data) => {
                if (data && data.length > 0) {
                    this.pdfPath = data[0].filePath;
                    this.pdfData = data[0].fileData;
                    this.pdfUrl = data[0].url;
                    this.reportFileName = data[0].reportFileName;
                    this.htmlElementSelector = data[0].htmlElementSelector;
                    var chartdata = data[0].data;
                    let pointCategoryNames = chartdata.map(el => el['pointscategoryname']);
                    let logData = [];
                    pointCategoryNames = pointCategoryNames.filter((el, index) => pointCategoryNames.indexOf(el) == index);
                    pointCategoryNames.forEach(el => {
                        let obj = {
                            category: el,
                            data: []
                        }
                        chartdata.forEach(element => {
                            if (el == element.pointscategoryname) {
                                //obj.data.concat(element.data);
                                obj.data.push(element.data);
                            }
                        })
                        logData.push(obj);
                    })
                    this.logData = logData;
                }
                this.fetchDataSpinner.dismiss();
            }, (error) => this.fetchDataSpinner.dismiss());
    }

    getMobileData(assetId) {
        this.mobileDataService.getMobileData(this.access_token, assetId, "logreport", null)
            .subscribe((data) => {
                if (data && data.length > 0) {
                    let pointCategoryNames = data.map(el => el['pointscategoryname']);
                    let logData = [];
                    pointCategoryNames = pointCategoryNames.filter((el, index) => pointCategoryNames.indexOf(el) == index);
                    pointCategoryNames.forEach(el => {
                        let obj = {
                            category: el,
                            data: []
                        }
                        data.forEach(element => {
                            if (el == element.pointscategoryname) {
                                //obj.data.concat(element.data);
                                obj.data.push(element.data);
                            }
                        })
                        logData.push(obj);
                    })
                    this.logData = logData;
                }
                this.fetchDataSpinner.dismiss();
            }, (error) => this.fetchDataSpinner.dismiss());
    }

    //This fetches the list of manual points for the given asset
    getManualPoints(token, assetId) {
        this.point = JSON.parse(this.newPoint);
        this.manualPoints = [];

        this.fetchDataSpinner = this.loadingCtrl.create({
            content: this.translate.instant('Fetchingdata'),
            spinner: 'bubbles'
        });
        this.fetchDataSpinner.present();
        this.manualPointService.getManualPoints(token, assetId,this.lan)
            .subscribe((data) => {
                if (data && data.length > 0) {
                    this.manualPoints = data;
                    this.mapManualPoints();
                }
                this.fetchDataSpinner.dismiss();
            }, (error) => this.fetchDataSpinner.dismiss());
    }

    /* --- Formatting and Post Upload Functionalites --- */

    ngOnDestroy() {
        if (this.platform.is("mobileweb") || this.platform.is("core")) {

        } else {
            this.db.close()
                .then((promise) => {
                    console.log('Closed');
                })
                .catch((error) => console.log('Error while closing db'))
        }
    }

    formatDate() {
        let date = new Date();
        let day = this.appendLeadingZero(date.getDate());
        let month = this.appendLeadingZero(date.getMonth()+1);
        let year = date.getFullYear();
        let hours = this.appendLeadingZero(date.getHours());
        let minutes = this.appendLeadingZero(date.getMinutes());
        let seconds = this.appendLeadingZero(date.getSeconds());
        return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    }

    appendLeadingZero(input) {
        if (input < 10) {
            return '0' + input;
        }
        return input;
    }

    downloadPDFNew() {        
        this.fetchDataSpinner = this.loadingCtrl.create({
            content: this.translate.instant('Downloading'),
            spinner: 'bubbles'
        });
        this.fetchDataSpinner.present();
        let body = {
            "url": this.pdfUrl,
            "htmlElementSelector": this.htmlElementSelector,
            "reportFileName": this.reportFileName,
            "Type": "Print"
        }
        this.mobileDataService.GenerateLogReports(this.access_token, body)
            .subscribe((data) => {
                if (data && data.length > 0) {
                    var blob = this.b64toBlob('data:application/pdf;base64,' + data[0].fileData, "application/pdf");
                    saveAs(blob, this.reportFileName);
                }
                this.fetchDataSpinner.dismiss();
            }, (error) => this.fetchDataSpinner.dismiss());
    }

    downloadPDF() {
        //  this.downloadPdfEvent.emit(true);
        var blob = this.b64toBlob('data:application/pdf;base64,' + this.pdfData, "application/pdf");
        //  var pdfname=this.pdfPath;
        let pdfname = this.pdfPath.split('Download' + '\\');
        var  fileName  = pdfname[1];
        saveAs(blob, fileName);
    }
    b64toBlob(b64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 512;
        b64Data = b64Data.replace(/^[^,]+,/, '');
        b64Data = b64Data.replace(/\s/g, '');
        var byteCharacters = window.atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    emailPdf() {
        let modal = this.modalCtrl.create(EmailDetailsComponent, {
            //pdfData: base64,
            filePath:this.pdfPath,
            pdfUrl:this.pdfUrl,
            htmlElementSelector:this.htmlElementSelector,
            reportFileName:this.reportFileName
          })
          modal.present();

        // this.emailPdfEvent.emit(this.pdfPath);
        // this.showEmailModal.emit(false);
    }

}



// WEBPACK FOOTER //
// ./src/components/reports/physical-readings/physical-readings.ts